import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({ name: 'filterMenu' })
export class FilterMenuPipe implements PipeTransform {
  private translate = inject(TranslateService);


  transform(items: any[], filter: any): any {
    if (!items || !filter) return items;

    const lang = this.translate.currentLang;
    const upperFilter = filter.toUpperCase();

    return items.filter(item => {
      let title = item.title || '';

      switch (lang) {
        case 'pt':
          title = item.ptTitle || item.title;
          break;
        case 'en':
          title = item.enTitle || item.title;
          break;
        case 'es':
          title = item.esTitle || item.title;
          break;
        default:
          title = item.title;
      }
      return title?.toUpperCase().includes(upperFilter);
    });
  }

}
